<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>图片流转工单管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="流转ID"
                        prop="id">
            <el-input placeholder="流转ID"
                      v-model="search.flow_id"></el-input>
          </el-form-item>
          <el-form-item label="工单ID"
                        prop="order_id">
            <el-input placeholder="工单ID"
                      v-model="search.order_id"></el-input>
          </el-form-item>
          <el-form-item label="识别状态">
            <el-select
              class="width-max"
              clearable
              v-model="search.status"
              placeholder="请选择识别状态">
              <el-option
                v-for="(label, value) in status"
                :key="value"
                :label="label"
                :value="value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="onSearch()">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="order_id"
                         label="工单ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="name"
                         label="工单名称"
                         min-width="200">
          <template slot-scope="scope">
            <router-link :to="'/order/review/'+scope.row.order_id"
                         target="_blank">{{scope.row.name}}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="图片识别进度"
                         min-width="90">
          <template slot-scope="scope">
            {{scope.row.detected_num}}/{{scope.row.images_num}}
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="识别状态"
                         width="200">
          <template slot-scope="scope">
            {{status[scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="添加日期"
                         width="190"></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新日期"
                         width="190"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="80">
          <template slot-scope="scope">
            <el-button
              :disabled="scope.row.status===0"
              type="danger"
              size="mini"
              @click="onReset(scope.$index, table)">重置
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../img-flow-order.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        order_id: null,
        flow_id: null,
      },
      exportHeader: [
        {
          key: 'order_id',
          text: '工单ID',
        },
        {
          key: 'name',
          text: '工单名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
      status: {
        0: '未识别',
        1: '已识别',
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getImgFlowOrderTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onReset (index, rows) {
      this.$confirm('此操作将重置该工单下的识别结果, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('resetImgFlowOrder', {id: rows[index].id}).then(() => {
          this.$message.success('重置成功')
          rows[index].status = 0
        })
      }).catch(() => {
        this.$message.info('已取消重置')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/img-flow-order/pages/ImgFlowOrderTable.vue